<app-saved-orders [customers]="[api.user]" (orderCharged)="api.goTo('commande')"></app-saved-orders>

<div class="surface-card px-4 py-2 md:px-6 lg:px-8 border-solid p-3 border-1 border-bottom-none mt-4"  style="border-color: #3e3e3e">
    <h2 class="m-0 p-0 py-2">Mes commandes passées</h2>
    <h3>Les étapes de ma commande (survolez la commande pour connaitre son statut)</h3>
    <div class="flex flex-column md:flex-row lg:gap-5">
        <div class="flex-auto border-left-3 border-top-none md:border-left-none md:border-top-3 pl-3 py-3 text-500" [ngClass]="{'border-primary text-primary surface-200':orderStep >= i+1}" *ngFor="let item of steps; let i = index">
            <div class="font-bold mb-2">ÉTAPE {{i+1}}</div>
            <span class="text-900 font-medium">{{item.details}}</span>
        </div>
    </div>
</div>

<div class="surface-card border-solid p-3 border-1 border-bottom-none" style="border-color: #3e3e3e">
	<app-period [default]="1" (myDates)="refresh($event)"></app-period>
</div>
<p-table [value]="orders" responsiveLayout="scroll" styleClass="p-datatable-gridlines" [loading]="api.loading">
    <ng-template pTemplate="header">
        <tr>
            <th>Ref. Devis</th>
            <th>Ref. Commande</th>
            <th>Date de création</th>
            <th>Date d'expédition</th>
            <th>Montant TTC</th>
            <th>Bon de livraison</th>
            <th>Facture</th>
            <th>Avoir</th>
            <th>Transporteur</th>
            <th>Actions</th>
        </tr>
        <tr *ngFor="let row of unregistered">
            <th colspan="2" align="center"><p-message severity="warn" text="En cours d'importation"></p-message></th>
            <th>{{row.date | date}}</th>
            <th></th>
            <th>{{row.sumTTC | currency:'EUR'}}</th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
        <tr (mouseenter)="setStep(row)" (mouseleave)="orderStep = 0" pTooltip="{{'ÉTAPE ' + orderStep}}" tooltipPosition='top'>
            <td>{{docs[row.Reference]['DE'] ? docs[row.Reference]['DE'].DocumentNumber : ''}}</td>
            <td>{{docs[row.Reference]['CM'] ? docs[row.Reference]['CM'].DocumentNumber : ''}}</td>
            <td>{{row.DocumentDate ? (row.DocumentDate.date | date) : ''}}</td>
            <td>{{docs[row.Reference]['BL'] && prepa[docs[row.Reference]['BL'].DocumentNumber] ? (prepa[docs[row.Reference]['BL'].DocumentNumber].date_expe | date) : ''}}</td>
            <td>{{docs[row.Reference]['FA'] ? (docs[row.Reference]['FA'].TotalDueAmount | currency : 'EUR') : (row.TotalDueAmount | currency : 'EUR')}}</td>

            <td class="p-0 text-center">
                <a class="no-underline" *ngIf="docs[row.Reference]['BL']" target="blank" href="https://ws.blackrockgames.fr/pdf.php?file={{docs[row.Reference]['BL'].DocumentNumber}}"><button pButton pRipple type="button" icon="pi pi-file-pdf" class="p-button-rounded p-button-primary p-button-outlined"></button></a>
            </td>
            <td class="p-0 text-center">
                <a class="no-underline" *ngIf="docs[row.Reference]['FA']" target="blank" href="https://ws.blackrockgames.fr/pdf.php?file={{docs[row.Reference]['FA'].DocumentNumber}}"><button pButton pRipple type="button" icon="pi pi-file-pdf" class="p-button-rounded p-button-primary p-button-outlined"></button></a>
            </td>
            <td class="p-0 text-center">
                <div class="flex flex-column align-items-center gap-1 py-1">
                    <a class="no-underline" *ngIf="docs[row.Reference]['AV']" target="blank" href="https://ws.blackrockgames.fr/pdf.php?file={{docs[row.Reference]['AV'].DocumentNumber}}"><button pButton pRipple type="button" icon="pi pi-file-pdf" class="p-button-rounded p-button-primary p-button-outlined"></button></a>
                    <p-tag
                        *ngIf="getCreditRequest(row) as creditReq"
                        [value]="creditStatusLabel(creditReq.status)"
                        [severity]="creditStatusSeverity(creditReq.status)"></p-tag>
                </div>
            </td>
            <td class="p-0 text-center">
            	<ng-container *ngIf="docs[row.Reference]['BL'] && prepa[docs[row.Reference]['BL'].DocumentNumber]; else noCar;let prepa">
            		<a target="blank" *ngIf="prepa.url && prepa.carrier" href="{{prepa.url}}">
            			<img class="m-auto border-circle" width="50" src="http://admin.blackrockgames.fr/api/classes/carrier/logos/{{prepa.carrier}}.jpg" />
            		</a>	
            	</ng-container>
            </td>
            <td class="p-0 text-center">
                <!-- <button
                    *ngIf="canRequestCredit(row)"
                    pButton
                    pRipple
                    type="button"
                    label="Demander un avoir"
                    class="p-button-sm p-button-outlined"
                    (click)="openCreditRequest(row)"></button> -->
            </td>
        </tr>
    </ng-template>
</p-table>
<ng-template #noCar></ng-template>

<p-dialog
    [(visible)]="displayCreditRequest"
    [modal]="true"
    [style]="{width: '560px'}"
    [position]="'top'"
    [closable]="!creditSubmitting"
    [blockScroll]="true">
    <p-header>Demande d'avoir</p-header>

    <div *ngIf="creditLoading" class="flex justify-content-center p-5">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
    </div>

    <div *ngIf="!creditLoading" class="flex flex-column gap-3">
        <p-message severity="info" [text]="'Facture ' + creditContext.InvoiceDocumentNumber" styleClass="w-full"></p-message>

        <div>
            <label class="font-bold block mb-2">Produit *</label>
            <p-dropdown
                [options]="creditLineOptions"
                [(ngModel)]="selectedCreditLine"
                optionLabel="label"
                optionValue="value"
                placeholder="Choisissez un produit"
                [filter]="true"
                [showClear]="true"
                styleClass="w-full"
                appendTo="body"
                (onChange)="onCreditLineSelect()"></p-dropdown>
        </div>

        <div *ngIf="selectedCreditLine" class="flex gap-3">
            <div class="flex-1">
                <label class="font-bold block mb-2">Quantité facturée</label>
                <p-inputNumber
                    [ngModel]="selectedCreditLine.Quantity"
                    [disabled]="true"
                    styleClass="w-full"
                    inputStyleClass="w-full"></p-inputNumber>
            </div>
            <div class="flex-1">
                <label class="font-bold block mb-2">Quantité demandée *</label>
                <p-inputNumber
                    [(ngModel)]="creditForm.qty_requested"
                    [min]="0.01"
                    [max]="selectedCreditLine.Quantity"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="2"
                    styleClass="w-full"
                    inputStyleClass="w-full"></p-inputNumber>
            </div>
        </div>

        <div>
            <label class="font-bold block mb-2">Raison *</label>
            <textarea
                id="creditReason"
                pInputTextarea
                [(ngModel)]="creditForm.reason"
                rows="4"
                class="w-full"
                placeholder="Expliquez votre demande"></textarea>
        </div>

        <div>
            <label class="font-bold block mb-2">Photos <span class="font-normal text-500">(max {{creditMaxPhotos}})</span></label>
            <p-fileUpload
                #creditPhotoUpload
                mode="basic"
                name="creditPhoto"
                accept="image/*"
                chooseLabel="Ajouter une photo"
                chooseIcon="pi pi-camera"
                [auto]="true"
                [disabled]="creditFileLoading || creditSubmitting || creditForm.photos.length >= creditMaxPhotos"
                (onSelect)="onCreditPhotoSelect($event); creditPhotoUpload.clear()"></p-fileUpload>
            <div *ngIf="creditFileLoading" class="mt-2 flex align-items-center gap-2">
                <p-progressSpinner [style]="{width: '24px', height: '24px'}" strokeWidth="4"></p-progressSpinner>
                <span class="text-500">Upload en cours…</span>
            </div>
            <p-message *ngIf="creditFileError" severity="error" [text]="creditFileError" styleClass="mt-2 w-full"></p-message>
            <div *ngIf="creditForm.photos.length" class="mt-3 flex flex-wrap gap-2">
                <div *ngFor="let photo of creditForm.photos; let i = index" class="relative">
                    <p-image [src]="photo" alt="Photo {{i+1}}" [preview]="true" width="100"></p-image>
                    <button
                        type="button"
                        pButton
                        pRipple
                        icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-sm absolute"
                        style="top: -8px; right: -8px;"
                        [disabled]="creditSubmitting"
                        (click)="removeCreditPhoto(i)"></button>
                </div>
            </div>
        </div>
    </div>

    <p-footer>
        <button
            type="button"
            pButton
            pRipple
            class="p-button-text"
            icon="pi pi-times"
            label="Annuler"
            [disabled]="creditSubmitting"
            (click)="displayCreditRequest = false"></button>
        <button
            type="button"
            pButton
            pRipple
            label="Envoyer la demande"
            [icon]="creditSubmitting ? 'pi pi-spin pi-spinner' : 'pi pi-send'"
            [disabled]="!canSubmitCredit()"
            (click)="submitCreditRequest()"></button>
    </p-footer>
</p-dialog>
